export class EventModel{
    constructor( event, webId ){         
        this.properties={}
        this.properties.webId=webId      
        this.name=event.NAME 
        this.properties.message=event.MESSAGE
    }  
}